import { Component, OnInit, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import { ValidationRegexPatterns } from '../../../Constants/ValidationRegexPatterns';
import { FormFlowFieldNumberTypes } from '../../../Constants/FormFlowFieldNumberTypes';
import { MatFormField, MatLabel } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/autocomplete';
import { MatCheckbox } from '@angular/material/checkbox';
@Component({
    selector: "app-regex-number-type",
    templateUrl: "./regex-number-type.component.html",
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => RegexNumberTypeComponent),
            multi: true
        }
    ],
    imports: [MatFormField, MatLabel, MatSelect, FormsModule, MatOption, MatCheckbox]
})
export class RegexNumberTypeComponent implements OnInit, ControlValueAccessor {
    val = null;
    isDisabled: boolean;
    numberType: string;
    allowNegativeNumbers: boolean = false;

    private readonly UNSIGNED_INTEGER: string = ValidationRegexPatterns.UnsignedIntegerInputRestriction;
    private readonly UNSIGNED_DECIMAL: string = ValidationRegexPatterns.UnsignedDecimalInputRestriction;
    private readonly INTEGER: string = ValidationRegexPatterns.SignedIntegerInputRestriction;
    private readonly DECIMAL: string = ValidationRegexPatterns.SignedDecimalInputRestriction;
    constructor() { }
    onChange: any = () => { };
    onTouch: any = () => { };
    setValue(val: string) {
        if (val !== undefined && this.val !== val) {
            this.val = val;
            this.onChange(val);
            this.onTouch(val);
            return;
        }
    }
    getValue() {
        return this.val;
    }
    writeValue(obj: any): void {
        switch (obj) {
            case this.UNSIGNED_INTEGER:
                this.numberType = FormFlowFieldNumberTypes.integer;
                this.allowNegativeNumbers = false;
                break;
            case this.UNSIGNED_DECIMAL:
                this.numberType = FormFlowFieldNumberTypes.decimal;
                this.allowNegativeNumbers = false;
                break;
            case this.DECIMAL:
                this.numberType = FormFlowFieldNumberTypes.decimal;
                this.allowNegativeNumbers = true;
                break;
            case this.INTEGER:
                this.numberType = FormFlowFieldNumberTypes.integer;
                this.allowNegativeNumbers = true;
                break;
        }
    }
    registerOnChange(fn: any): void {
        this.onChange = fn;
    }
    registerOnTouched(fn: any): void {
        this.onTouch = fn;
    }
    setDisabledState?(isDisabled: boolean): void {
        this.isDisabled = isDisabled;
    }
    ngOnInit() { }
    numberTypeChanged(numberType: string) {
        const value = this.processValueFromInputs(
            this.isDecimal(numberType),
            this.allowNegativeNumbers
        );
        this.setValue(value);
    }
    negativeNumbersChanged(allowNegativeNumbers: boolean) {
        const value = this.processValueFromInputs(
            this.isDecimal(this.numberType),
            allowNegativeNumbers
        );
        this.setValue(value);
    }
    processValueFromInputs(isDecimal: boolean, allowNegative: boolean): string {
        switch (allowNegative) {
            case true:
                if (isDecimal) {
                    return this.DECIMAL;
                } else {
                    return this.INTEGER;
                }
            case false:
                if (isDecimal) {
                    return this.UNSIGNED_DECIMAL;
                } else {
                    return this.UNSIGNED_INTEGER;
                }
        }
    }
    private isDecimal(numberType: string): boolean {
        return numberType === FormFlowFieldNumberTypes.decimal;
    }
}